// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  version: '2.0.0',
  production: false,
  showCookies: true,
  googleMapsApiKey: 'AIzaSyCr31xNNOurbBAHbwe_9QzA_5rYKzwSHxU',
  apiRoot: 'https://be-test-ubie.app.ubiecloud.com/jwtapi',
  server: 'https://be-test-ubie.app.ubiecloud.com',
  logRoot: 'http://localhost:1337/api',
  imageRoot: 'https://ubiecloud.com',
  linkRoot: 'https://be-test-ubie.app.ubiecloud.com',
  mqtt: {
    host: 'be-test.mqtt.ubiecloud.com',
    hostname: 'be-test.mqtt.ubiecloud.com',
    user: '',
    pass: '',
    keepalive: 40,
    port: 8081,
    ssl: true,
    path: '',
    retain: false,
  },
  configurations: {
    pagesConfig: 'pagesConfig',
  },
  calendar: 'https://be-test-calendar.app.ubiecloud.com/api',
  admin: false,
  semsaWizardUrl: 'http://semsawizard.be-test-ubie.app.ubiecloud.com',
  lqsBoxWizardUrl: 'https://lqsboxwizard.be-test-ubie.app.ubiecloud.com',
  updateUri:
    'https://be-test-ubie.app.ubiecloud.com/appchangelog/update-changelogv2.json',
  publishers: [
    {
      loggerName: 'console',
      loggerLocation: '',
      isActive: true,
    },
    {
      loggerName: 'sqlite',
      loggerLocation: '',
      isActive: true,
    },
  ],
  sonosClientId: '3d2ba48b-59ae-4893-96fb-d8a0ef23e2a6',
  shouldCache: false,
  isUbieTouch: false,
  rtcConfig: {
    iceServers: [],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
